import { render, staticRenderFns } from "./ContributorHeader.vue?vue&type=template&id=4a8c6a01&scoped=true&"
import script from "./ContributorHeader.vue?vue&type=script&lang=js&"
export * from "./ContributorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContributorHeader.vue?vue&type=style&index=0&id=4a8c6a01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c6a01",
  null
  
)

export default component.exports